import type { WhatsappMessage } from "@stockline/shared/types/communications/whatsapp-message"
import type { OfflineResourceConfig } from "../../../types"
import { WHATSAPP_MESSAGE_TABLE } from "./db"

export const whatsappMessageConfig: OfflineResourceConfig<WhatsappMessage> = {
  name: "whatsapp-messages",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  // STK-1324: deferred, non-blocking -- hydrated via the SSE replay handshake
  // (cursor=0 full-table replay) AFTER readiness, not the cold-start waves.
  tier: "background",
  endpoints: {
    full: "/api/v2/whatsapp-messages",
    delta: "/api/v2/whatsapp-messages/changes",
    push: "/api/v2/whatsapp-messages/changes",
  },
  tableName: WHATSAPP_MESSAGE_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    chatUid: "chatUid",
    status: "status",
    isFromMe: "isFromMe",
    timestamp: "timestamp",
    syncId: "syncId",
    "[chatUid+timestamp]": "[chatUid+timestamp]",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
